import { createContext, useContext, useRef } from "react"
import { create, useStore } from "zustand"

interface PreventionProgramsState {
  actionedPreventionPrograms: Record<string, "DISMISSED" | "REFERRED">
  markPreventionProgramAsDismissed: (programId: string) => void
  markPreventionProgramAsReferred: (programId: string) => void
}

const createPreventionProgramsStore = () => {
  return create<PreventionProgramsState>((set) => ({
    actionedPreventionPrograms: {},
    markPreventionProgramAsDismissed: (programId) =>
      set((state) => ({
        actionedPreventionPrograms: { ...state.actionedPreventionPrograms, [programId]: "DISMISSED" },
      })),
    markPreventionProgramAsReferred: (programId) =>
      set((state) => ({
        actionedPreventionPrograms: { ...state.actionedPreventionPrograms, [programId]: "REFERRED" },
      })),
  }))
}

type PreventionProgramsStoreType = ReturnType<typeof createPreventionProgramsStore>

const PreventionProgramsStoreContext = createContext<PreventionProgramsStoreType | null>(null)

export const PreventionProgramsProvider = ({ children }: React.PropsWithChildren) => {
  const storeRef = useRef<PreventionProgramsStoreType>(undefined)
  if (!storeRef.current) {
    storeRef.current = createPreventionProgramsStore()
  }
  return (
    <PreventionProgramsStoreContext.Provider value={storeRef.current}>
      {children}
    </PreventionProgramsStoreContext.Provider>
  )
}

export function usePreventionProgramsStoreContext<T>(selector: (state: PreventionProgramsState) => T): T {
  const store = useContext(PreventionProgramsStoreContext)
  if (!store) throw new Error("Missing PreventionProgramsProvider in the tree")
  return useStore(store, selector)
}
